import { render, staticRenderFns } from "./AscAdvancedCustomAlertsRecActionWrapper.vue?vue&type=template&id=4ae3f770&"
import script from "./AscAdvancedCustomAlertsRecActionWrapper.vue?vue&type=script&lang=js&"
export * from "./AscAdvancedCustomAlertsRecActionWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscAdvancedCustomAlertsRecActionWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports